import { filter, map, Observable } from 'rxjs';

import {
  DocumentVisibility,
  trackChangesWhenInactive,
} from '@neptune/shared/common-business-logic';
import {
  getProjectNotificationStream,
  ProjectNotification,
} from '@neptune/shared/core-project-business-logic';
import { EntityLeaderboardNotification } from '@neptune/shared/entity-leaderboard-domain';

type GetEntityLeaderboardNotificationStreamParams = {
  projectId: string;
  entityTypes: string[];
};

export function getEntityLeaderboardNotificationStream({
  projectId,
  entityTypes,
}: GetEntityLeaderboardNotificationStreamParams): Observable<EntityLeaderboardNotification> {
  const projectNotifications$ = getProjectNotificationStream({ projectId });

  return projectNotifications$.pipe(
    filter(isProjectLeaderboardChangedNotification),
    filter((notification) => matchEntityTypes(entityTypes, notification)),
    trackChangesWhenInactive(
      DocumentVisibility.fromVisibilityChange().pipe(map(() => DocumentVisibility.isAppHidden())),
    ),
  );
}

export function isProjectLeaderboardChangedNotification(
  notification: ProjectNotification,
): notification is EntityLeaderboardNotification {
  return notification.messageType === 'ProjectLeaderboardChanged';
}

export function matchEntityTypes(
  entityTypes: string[],
  notification: EntityLeaderboardNotification,
): boolean {
  const notificationEntityTypes = notification.messageBody.experimentTypes;
  return entityTypes.some((entityType) => notificationEntityTypes.includes(entityType));
}
